const { createContext, useState, useContext, useEffect } = require("react");

const stepperContext = createContext();

export function StepperProvider({
  children,
  steps = [],
  active = 0,
  autoScroll = true,
}) {
  const [activeStep, setActiveStep] = useState(active);

  useEffect(() => {
    if (!!autoScroll) {
      window.scrollTo(0, 0);
    }
  }, [activeStep, autoScroll]);

  function back() {
    if (activeStep > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  }

  function next() {
    if (activeStep < steps.length) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  }

  function reset() {
    setActiveStep(0);
  }

  return (
    <stepperContext.Provider
      value={{
        steps,
        activeStep,
        back,
        next,
        reset,
        isFirstStep: activeStep === 0,
        isLastStep: activeStep === steps.length - 1,
        isFinish: activeStep === steps.length,
      }}
    >
      {children}
    </stepperContext.Provider>
  );
}

export function useStepperContext() {
  const context = useContext(stepperContext);

  if (!context) {
    throw new Error("useStepper should be used inside the StepperProvider.");
  }

  return context;
}
